import { createFileRoute } from '@tanstack/react-router';
import { MasterWorkspacesScreen } from '@/mobile/master/screens/MasterWorkspacesScreen';

export const Route = createFileRoute('/m/master/workspaces/')({
  component: MasterWorkspacesScreen,
});
